module.exports = {
  email: {
    en: "E-mail",
    fr: "E-mail"
  },
  no: {
    en: "No",
    fr: "Non"
  },
  yes: {
    en: "Yes",
    fr: "Oui"
  },
  title_delete_check: {
    en: "Warning: deleting a warded element",
    fr: "Destruction d'un élément important"
  },
  content_delete_check: {
    en: "You are deleting a warded element. The deletion is an irreversible action, do you really want to delete the element selected ?",
    fr: "La destruction de cette élément est irreversible, voulez-vous vraiment poursuivre l'action ?"
  },
  name: {
    en: "Name",
    fr: "Nom"
  },
  send: {
    en: "Send",
    fr: "Envoyer"
  },
  company: {
    en: "Company",
    fr: "Entreprise"
  },
  message: {
    en: "Message",
    fr: "Message"
  },
  remove: {
    en: "Delete",
    fr: "Supprimer"
  },
  confirm: {
    en: "Confirm",
    fr: "Confirmer"
  },
  cancel: {
    en: "Cancel",
    fr: "Annuler"
  },
  edit: {
    en: "Edit",
    fr: "Modifier"
  },
  groups: {
    en: "Groups",
    fr: "Groupes"
  },
  projects: {
    en: "Projects",
    fr: "Projets"
  },
  profile: {
    en: "Profile",
    fr: "Profil"
  },
  pseudo: {
    en: "Pseudo",
    fr: "Pseudo"
  },
  member: {
    en: "Member",
    fr: "Membre"
  },
  description: {
    en: "Description",
    fr: "Description"
  },
  apps: {
    en: "Apps",
    fr: "Applications"
  },
  licences: {
    en: "Licences",
    fr: "Licences"
  },
  manage: {
    en: "Manage",
    fr: "Gérer"
  },
  users: {
    en: "Users",
    fr: "Utilisateurs"
  },
  service: {
    en: "Service",
    fr: "Service"
  },
  password: {
    en: "Password",
    fr: "Mot de passe"
  },
  permissions: {
    createService: {
      en: "Service creation",
      fr: "Création de service"
    },
    createMember: {
      en: "Member creation",
      fr: "Création de membre"
    },
    createGroup: {
      en: "Group creation",
      fr: "Création de groupe"
    },
    createProject: {
      en: "Project creation",
      fr: "Création de projet"
    },
    createRole: {
      en: "Role creation",
      fr: "Création de rôle"
    },
    modifyMemberRole: {
      en: "Member's role edition",
      fr: "Modification des rôles des membres"
    },
    modifyGroupName: {
      en: "Group's name and description edition",
      fr: "Modification du nom et de la description d'un groupe"
    },
    modifyGroupRoles: {
      en: "Group's roles edition",
      fr: "Modification des rôles d'un groupe"
    },
    modifyGroupUsers: {
      en: "Group's user edition",
      fr: "Modification des utilisteurs d'un groupe"
    },
    modifyProject: {
      en: "Project edition",
      fr: "Modification de projet"
    },
    modifyProjectApps: {
      en: "Project's apps edition",
      fr: "Modification des application d'un projet"
    },
    modifyProjectUsers: {
      en: "Project's users edition",
      fr: "Modification des utilisateurs d'un projet"
    },
    modifyMemberData: {
      en: "Member's information edition",
      fr: "Modification de données des membres"
    },
    modifyUserPseudo: {
      en: "User's pseudo edition",
      fr: "Modification du pseudo d'un utilisateur"
    },
    modifyUserSettings: {
      en: "User's settings edition",
      fr: "Modification des paramètres d'un utilisateur"
    },
    modifyService: {
      en: "Service edition",
      fr: "Modification des services"
    },
    modifyRole: {
      en: "Role edition",
      fr: "Modification des rôles"
    },
    modifyUserRole: {
      en: "User's role edition",
      fr: "Modification du rôle d'un utilisateur"
    },
    removeMember: {
      en: "Member deletion",
      fr: "Suppression de membres"
    },
    removeGroup: {
      en: "group deletion",
      fr: "Suppression de groupe"
    },
    removeProject: {
      en: "Project deletion",
      fr: "Suppression de projet"
    },
    removeService: {
      en: "Service deletion",
      fr: "Suppression de service"
    },
    removeRole: {
      en: "Role deletion",
      fr: "Suppression de rôle"
    },
    modifyPseudo: {
      en: "Mofify pseudo",
      fr: "Modification de son propre pseudo"
    },
    modifyAvatar: {
      en: "Modify avatar",
      fr: "Modification de son propre avatar"
    },
    modifyUserProfile: {
      en: "Modify user profile",
      fr: "Modification du profil utilisateur"
    },
    createProfile: {
      en: "Create profile",
      fr: "Création d'un profil"
    },
    modifyProfile: {
      en: "Modify profile",
      fr: "Modification d'un profil"
    },
    removeProfile: {
      en: "Remove profile",
      fr: "Suppression d'un profil"
    },
    modifyGroupProfiles: {
      en: "Modify group profile",
      fr: "Modification des profils de groupe"
    },
    createAPIs: {
      en: "Create API",
      fr: "Création d'API"
    },
    modifyAPIs: {
      en: "Modify API",
      fr: "Modification d'API"
    },
    removeAPIs: {
      en: "Remove API",
      fr: "Suppression d'API"
    },
    createApp: {
      en: "Create app",
      fr: "Création d'application"
    },
    removeApp: {
      en: "Remove app",
      fr: "Suppression d'une application"
    },
    modifyApp: {
      en: "App edition",
      fr: "Modification d'une application"
    },
    createLicence: {
      en: "Create licence",
      fr: "Création de licence"
    },
    removeLicence: {
      en: "Remove licence",
      fr: "Suppression d'une licence"
    },
    modifyLicence: {
      en: "Licence edition",
      fr: "Modification d'une licence"
    },
    createTheme: {
      en: "Create theme",
      fr: "Création d'un thème"
    },
    removeTheme: {
      en: "Remove theme",
      fr: "Suppression d'un thème"
    },
    modifyTheme: {
      en: "Theme edition",
      fr: "Modification d'un thème"
    },
    createInvitation: {
      en: "Create invitation",
      fr: "Création d'invitation"
    },
    removeInvitation: {
      en: "Remove invitation",
      fr: "Suppression d'invitation"
    },
    modifyInvitation: {
      en: "Invitation edition",
      fr: "Modification d'invitation"
    },
    removeUser: {
      en: "Remove user",
      fr: "Suppression d'utilisateur"
    }
  },
  passwordError: {
    errUppercase: {
      en: "",
      fr: ""
    },
    errLowercase: {
      en: "",
      fr: ""
    },
    errLength: {
      en: "",
      fr: ""
    },
    errNumber: {
      en: "",
      fr: ""
    },
    errSpecialChar: {
      en: "",
      fr: ""
    }
  }
}
